
export const breakpointSize = {
  xs: 400, // for small screen mobile
  sm: 640, // for mobile screen
  md: 770, // for tablets
  lg: 1024, // for laptops
  xl: 1440, // for desktop / monitors
  xxl: 1920, // for big screens
};

export const breakpoints = {
  xs: `(min-width: ${breakpointSize.xs}px)`,
  sm: `(min-width: ${breakpointSize.sm}px)`,
  md: `(min-width: ${breakpointSize.md}px)`,
  lg: `(min-width: ${breakpointSize.lg}px)`,
  xl: `(min-width: ${breakpointSize.xl}px)`,
  xxl: `(min-width: ${breakpointSize.xxl})`,
  down: key => `(max-width: ${breakpointSize[key]}px)`,
  up: key => `(min-width: ${breakpointSize[key] + 1}px)`,
  _down: key => window.innerWidth <= breakpointSize[key],
  _up: key => window.innerWidth > breakpointSize[key],
};

export const isScreen = (value) => {
  return breakpoints._down(value)
}